<div class="w-full min-h-screen bg-[#eef2f7]">
  <app-header />
  <router-outlet />
  <app-toast />
</div>
